"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _user = require("@/api/user");
var _filters = require("@/filters");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'OrderDetail',
  data: function data() {
    return {
      direction: 'rtl',
      dialogVisible: false,
      orderDatalist: {},
      loading: false
    };
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    filterCardType: _filters.filterCardType,
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 订单信息
    getDetail: function getDetail(id) {
      var _this = this;
      this.loading = true;
      (0, _user.memberOrderInfoApi)(id).then(function (res) {
        _this.orderDatalist = res;
        _this.loading = false;
      }).catch(function () {
        _this.orderDatalist = null;
        _this.loading = false;
      });
    }
  }
};